module.exports = __webpack_public_path__ + "img/ref-1.17791650.jpg";